<template lang="pug">
  v-layout(column)
    svg#chartProgressBar(ref="chartProgressBar" xmlns="http://www.w3.org/2000/svg" style="height:25px")

      //- Background Line
      rect#greyBgLine( :width="lineWidth" :height="height" fill="#CCCCCC" fill-opacity="1"  transform="translate(10,7.5)")
      //- Forward Line
      rect( :width="getButtonXpos" :height="height" :fill="$vuetify.theme.themes.light.accent" fill-opacity="1"  transform="translate(10,7.5)")
      circle(id="scrubDot" :style="isDragging?{'cursor':'grabbing','fill':'white'}:{'cursor':'grab'}" @mousedown.prevent="startDrag" @touchstart.prevent="startDrag" :cx="getButtonXpos" cy="10" r="10" :fill="$vuetify.theme.themes.light.primary" stroke-width="1" transform="translate(10,0)")

</template>
<script>
export default {
  props: {
    value: Number
  },
  data: () => ({
    height: 5,
    lineWidth: 100,

    isDragging: false,
    x: 0,
    originX: 0
  }),

  mounted() {
    this.lineWidth =this.$refs.chartProgressBar.getBoundingClientRect().width - 20;
  },

  beforeDestroy() {
    // in case the component is torn down mid-drag
    this.removeDragListeners();
  },

  computed: {
    getButtonXpos: function() {
      if (this.isDragging) {
        return this.x;
      } else {
        return (this.value / 100) * this.lineWidth;
      }
    }
  },

  methods: {
    startDrag: function(event) {
      this.isDragging = true;
      this.originX = event.clientX - event.target.getBoundingClientRect().x;

      window.addEventListener("mouseup", this.stopDrag);
      window.addEventListener("touchend", this.stopDrag);
      window.addEventListener("mousemove", this.doDrag);
      window.addEventListener("touchmove", this.doDrag);




    },

    removeDragListeners: function() {
      window.removeEventListener("mouseup", this.stopDrag);
      window.removeEventListener("touchend", this.stopDrag);
      window.removeEventListener("mousemove", this.doDrag);
      window.removeEventListener("touchmove", this.doDrag);
    },

    stopDrag: function(event) {
      this.isDragging = false;
      console.log(`stop drag ${event} ${(this.x / this.lineWidth)*100}`);
      this.$emit("input",(this.x / this.lineWidth)*100)

      // the touch pair used to be left registered, leaking two listeners per drag
      this.removeDragListeners();
    },

    doDrag: function(event) {
      event.preventDefault();
      if (this.isDragging) {
        this.x =
          event.clientX -
          this.$refs.chartProgressBar.getBoundingClientRect().x -
          this.originX;

        // constraint to 0
        if (this.x < 0) {
          this.x = 0;
        }

        // constraint to maximum value
        if (this.x > this.lineWidth) {
          this.x = this.lineWidth;
        }

        this.$emit("input",(this.x / this.lineWidth)*100)
        // this.$store.timeline.progress(this.x / this.lineWidth);
        // console.log(event.target.getBoundingClientRect());
        // console.log(
        //   `mouse Move ${event} x:${this.x}, percent:${this.x / this.lineWidth}`
        // );
      }
    }
  }
};
</script>
<style scoped lang="stylus">
#chartProgressBar {
  width: calc(100% + 20px);
  height: 20px;
  margin-left: -10px;
}
#scrubDot {
  -webkit-filter: drop-shadow( 4px 4px 3px rgba(0, 0, 0, .7));
  filter: drop-shadow( 4px 4px 3px rgba(0, 0, 0, .7));
}

#scrubDot:hover{
  cursor: grab
  fill: white
}
</style>
